export default {
  getAll: {
    url: '/api/invoice/getAll',
    method: 'get'
  },
  create: {
    url: '/api/invoice/create',
    method: 'post'
  },
  update: {
    url: '/api/invoice/update',
    method: 'put'
  },
  delete: {
    url: '/api/invoice/delete',
    method: 'delete'
  },
  picUpload: {
    url: '/api/invoice/picUpload',
    method: 'post'
  }
}



// WEBPACK FOOTER //
// ./src/api/invoice.js